import React, { useEffect } from 'react';
import { Grid, Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import AuthenticationComp from './AuthenticationComp';
import Criteria from './Criteria';

const Home = () => {
	const { t } = useTranslation();
	useEffect(() => {
		sessionStorage.removeItem('accountMessage');
		document.title = `${t('title')} | ${t('home')}`;
	}, [t]);
	return (
		<div className='home-container'>
			<Container className='home-container-text'>
				<Grid container direction='column' spacing={2}>
					<Grid item>
						<Grid container spacing={2}>
							<Grid item xs={12} sm={12} md={7}>
								<Criteria />
							</Grid>
							<Grid item xs={12} sm={12} md={5}>
								<AuthenticationComp />
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Container>
		</div>
	);
};

export default Home;
